module.exports = __webpack_public_path__ + "img/main_logo.92013167.png";